module.exports = __webpack_public_path__ + "static/media/translator.d9df209d.mp4";